export const getAuthToken = () => {
    if (localStorage.getItem('admin_wallet_token')) {
        return localStorage.getItem('admin_wallet_token')
    }
    return '';
}